<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeRelanceOption.title')}}</h1>
              <breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()" class="column is-12">
            <b-input :placeholder="$t('listeRelanceOption.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('listeRelanceOption.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="relancesOption.length === 0">
      <div class="card-content" >
        <div class="has-text-centered pdt-20px pdb-20px">
          <h1 class="title is-size-4">
            {{ $t('listeRelanceOption.messages.errors.noResult')}}
          </h1>
        </div>
      </div>
    </div>
    <div v-else v-for="(relanceOption, index) in relancesOption" :key="index"
         class="card mgb-20px">
      <relance-option :relanceOption="relanceOption"/>
    </div>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-relance-option ref="filtreListeRelanceOption"
                            @toggleFiltre="setShowFiltre"
                            @recherche="makeRechercheFilter"
        />
      </div>
    </transition>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import messageErreur from '@/services/general/messageErreur';
import critereRechercheBaseRelanceOption from '@/services/relanceOption/critereRechercheBaseRelanceOption';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import relanceOption from '@/components/relanceOption/relanceOption';
import filtreListeRelanceOption from '@/components/relanceOption/filtreListeRelanceOption';

const RelanceOption = createNamespacedHelpers('relanceOption');
const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      showFiltre: false,
    };
  },
  components: {
    breadcrumb,
    relanceOption,
    filtreListeRelanceOption,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...RelanceOption.mapGetters({
      relancesOption: 'items',
      totalCount: 'totalCount',
      criteresRecherche: 'criteresRecherche',
    }),
    breadcrumb() {
      return [
        { title: this.$t('listeRelanceOption.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeRelanceOption.breadcrumb.liste'), route: { name: '' }, isActive: true },
      ];
    },
    nombreCritere() {
      const banCritere = ['auto', 'types', 'tiersId', 'typesProduits', 'typesDevisCommandeFacture', 'etatsDevisCommandeFacture', 'dateVisualisation', 'sens', 'societeId'];
      const nbCritere = calculNombreCritere(this.criteresRecherche, banCritere);
      return nbCritere > 9 ? '+9' : nbCritere;
    },
  },
  methods: {
    ...RelanceOption.mapActions({
      loadRelanceOption: 'loadRelanceOption',
    }),
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeRelanceOption.initializeFiltre();
    },
    makeRechercheFilter() {
      this.setShowFiltre();
      this.recherche();
    },
    async recherche() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const data = {
          query: cloneDeep(this.criteresRecherche),
          limit: NO_PAGINATION,
        };
        critereRechercheBaseRelanceOption(data.query);
        data.query.societeId = this.societeActiveId;
        await this.loadRelanceOption(data);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async reinitialiser() {
      await this.$refs.filtreListeRelanceOption.initializeFiltre();
      this.$refs.filtreListeRelanceOption.viderCritere();
      this.$refs.filtreListeRelanceOption.appliquerCritere();
      this.showFiltre = false;
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageGescom.relanceOption.liste'));
    this.recherche();
  },
};

</script>
